import { configureStore, ThunkAction, Action, Reducer } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; // Defaults to localStorage for web
import propertiesReducer from "./slice/propertiesSlice";
import userReducer from "./slice/userSlice";
import menuReducer from "./slice/menuSlice";
import ledgerReducer from "./slice/ledgerSlice";
import documentReducer from "./slice/documentSlice";
import fundReducer from "./slice/fundAndTransactionSlice";
import propertyDetailReducer from "./slice/propertyDetailsSlice";
import accountReducer from "./slice/accountSlice";
import businessReducer from "./slice/businessSlice";
import getAuctionIdReducer from "./slice/auctionIdSlice";
import myBidReducer from "./slice/mybidSlice";
import calenderPropertiesReducer from "./slice/calenderPropertiesSlice";
import editanddeleteuserReducer from './slice/userSlice'
import favoritePropertyReducer from './slice/favoritePropertySlice';
import broadcastMessagesReducer from './slice/broadcastMessagesSlice';
import signedAgreementReducer from './slice/signedagreementSlice'
import selectedProfileReducer from './slice/selectedProfileSlice';
import stateCountyReducer from './slice/countyStateSlice';
import purchaseProfileReducer from './slice/PurchaseProfileList';
import incrementReducer from './slice/incrementSlice';
import navigationReducer from './slice/navigationSlice';
import kybReducer from './slice/kybSlice'
import { getEmailStatus } from './slice/userSlice';

// Persist configurations for the relevant slices
const businessPersistConfig = { key: "business", storage };
const userPersistConfig = { key: "user", storage };
const auctionIdPersistConfig = { key: "auctionId", storage };
const stateCountyPersistConfig = { key: "stateCounty", storage };
const ledgerPersistConfig = { key: "ledger", storage };
const documentPersistConfig = { key: "document", storage };
const fundPersistConfig = { key: "fund", storage };
const accountPersistConfig = { key: "account", storage };
const myBidPersistConfig = { key: "myBid", storage };
const purchaseProfilePersistConfig = { key: "purchaseProfile", storage };
const editanddeleteuserConfig = {
  key: 'editanddeleteuser', // Corrected typo here
  storage,
};
const kybPersistConfig = { key: "kyb", storage };

const selectedProfileConfig = {
  key: 'selectedProfile', // Corrected typo here
  storage,
};

const broadcastMessagesConfig = {
  key: 'broadcastMessages', // Corrected typo here
  storage,
};

const emailStatusPersistConfig = {
  key: 'emailStatus',
  storage,
};

const navigationPersistConfig = { key: "navigation", storage };

// Persist the reducers
const persistedUserReducer = persistReducer(userPersistConfig, userReducer);
const persistedAuctionIdReducer = persistReducer(auctionIdPersistConfig, getAuctionIdReducer);
const persistedStateCountyReducer = persistReducer(stateCountyPersistConfig, stateCountyReducer);
const persistedLedgerReducer = persistReducer(ledgerPersistConfig, ledgerReducer); // Persist the ledger slice
const persistedDocumentReducer = persistReducer(documentPersistConfig, documentReducer); // Persist the document slice
const persistedFundReducer = persistReducer(fundPersistConfig, fundReducer); // Persist the document slice
const persistedBusinessReducer = persistReducer(businessPersistConfig, businessReducer); // Persist the business slice
const persistedAccountReducer = persistReducer(accountPersistConfig, accountReducer); // Persist the account slice
const persistedMyBidReducer = persistReducer(myBidPersistConfig, myBidReducer); // Persist the mybid slice
const persistedEditanddeleteuserReducer = persistReducer(editanddeleteuserConfig, editanddeleteuserReducer); // Persist the mybid slice
const persistedSelectedProfileReducer = persistReducer(selectedProfileConfig, selectedProfileReducer);
const persistedBroadcastMessagesReducer = persistReducer(broadcastMessagesConfig, broadcastMessagesReducer);
const persistedPurchaseProfileReducer = persistReducer(purchaseProfilePersistConfig, purchaseProfileReducer);
const persistedNavigationReducer = persistReducer(navigationPersistConfig, navigationReducer);
const persistedkybReducer = persistReducer(kybPersistConfig, kybReducer);
const persistedEmailStatusReducer = persistReducer(emailStatusPersistConfig, getEmailStatus);
// Configure the store
const store = configureStore({
  reducer: {
    properties: propertiesReducer,
    user: persistedUserReducer,
    menu: menuReducer,
    stateCounty: persistedStateCountyReducer,
    ledger: persistedLedgerReducer,
    document: persistedDocumentReducer,
    business: persistedBusinessReducer,
    account: persistedAccountReducer,
    propertyDetails: propertyDetailReducer,
    auctionId: persistedAuctionIdReducer,
    fund: fundReducer,
    mybid: persistedMyBidReducer,
    calenderProperties: calenderPropertiesReducer,
    editanddeleteuser: persistedEditanddeleteuserReducer,
    favoriteProperties: favoritePropertyReducer,
    broadcastMessages: broadcastMessagesReducer,
    selectedProfile: persistedSelectedProfileReducer,
    broadcastMessagesSave: persistedBroadcastMessagesReducer,
    signedAgreement: signedAgreementReducer,
    purchaseProfile: persistedPurchaseProfileReducer,
    increment: incrementReducer,
    navigation: persistedNavigationReducer,
    kyb: persistedkybReducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["persist/PERSIST", "persist/REHYDRATE"],
      },
    }),
});
export const setupStore = (preloadedState?: Partial<RootState>) => {
  return configureStore({
    reducer: {
      properties: propertiesReducer as Reducer,
      user: persistedUserReducer as Reducer,
      menu: menuReducer as Reducer,
      stateCounty: persistedStateCountyReducer as Reducer,
      ledger: persistedLedgerReducer as Reducer,
      document: persistedDocumentReducer as Reducer,
      business: persistedBusinessReducer as Reducer,
      account: persistedAccountReducer as Reducer,
      propertyDetails: propertyDetailReducer as Reducer,
      auctionId: persistedAuctionIdReducer as Reducer,
      fund: fundReducer as Reducer,
      mybid: persistedMyBidReducer as Reducer,
      calenderProperties: calenderPropertiesReducer as Reducer,
      editanddeleteuser: persistedEditanddeleteuserReducer as Reducer,
      favoriteProperties: favoritePropertyReducer as Reducer,
      broadcastMessages: broadcastMessagesReducer as Reducer,
      selectedProfile: persistedSelectedProfileReducer as Reducer,
      broadcastMessagesSave: persistedBroadcastMessagesReducer as Reducer,
      signedAgreement: signedAgreementReducer as Reducer,
      purchaseProfile: persistedPurchaseProfileReducer as Reducer,
      increment: incrementReducer as Reducer,
      navigation: persistedNavigationReducer as Reducer,
      kyb: persistedkybReducer as Reducer
    }, 
    preloadedState,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: {
          ignoredActions: ["persist/PERSIST", "persist/REHYDRATE"],
        },
      }),
  });
}
// Create the persistor
const persistor = persistStore(store);

export { store, persistor };

// Type definitions for your store
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
export type AppStore = ReturnType<typeof setupStore>
